import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  assetManagementQuestionnaireStatus: string,
 *  closeYearStatus: string,
 *  completedProjects: number,
 *  financialsLastUpdated: string,
 *  insuranceStatus: string,
 *  riskManagementQuestionnaireStatus: string,
 *  totalProjects: number }} reportSummary
 */

const api = new Api("api/municipalities");

/**
 * @param {number} id
 * @returns {Promise<AxiosResponse<reportSummary>>}
 */
export const getById = (id) => api.get(`${id}/report/summary`);
